var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poi-searching"},_vm._l((Array(3)),function(o,i){return _c('div',{key:i,staticClass:"dot",class:("dot-" + i)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }